import type { ProductCategoryCard } from '../constants';

type ProductItem = {
  label: string;
  path: string;
  image: string;
  globalOrder: number;
};

type ProductCollection = {
  basePath: string;
  items: ProductItem[];
};

type ProductCategories = {
  [key: string]: ProductCollection;
};

/**
 * Creates product category cards from the categories data
 * @param categories - The product categories data
 * @returns Array of product category cards sorted by global order
 */
export const createProductCategoryCards = (categories: ProductCategories): ProductCategoryCard[] => {
  const cards = Object.entries(categories).flatMap(([, { basePath, items }]) =>
    items.map(({ label, path, image, globalOrder }) => ({
      label,
      url: `${basePath}/${path}/`,
      image,
      globalOrder,
    })),
  );

  return [...cards].sort((a, b) => (a.globalOrder || 0) - (b.globalOrder || 0));
};

/**
 * Gets categories by collection key
 * @param categories - The product categories data
 * @param collectionKey - The collection key to filter by
 * @returns Array of product category cards for the specified collection
 */
export const getCategoriesByCollection = (
  categories: ProductCategories,
  collectionKey: string,
): ProductCategoryCard[] => {
  const collection = categories[collectionKey];
  if (!collection) {
    return [];
  }

  return collection.items.map(({ label, path, image, globalOrder }) => ({
    label,
    url: `${collection.basePath}/${path}/`,
    image,
    globalOrder,
  }));
};
